module.exports = __webpack_public_path__ + "img/transfer-loading.84961f69.gif";